import { Component } from '@angular/core';

@Component({
  selector: 'app-ui-button',
  templateUrl: './ui-button.component.html',
  styleUrls: ['./ui-button.component.css']
})
export class UiButtonComponent {
  /**
   * Header button list show
   */
  Settingicon = true;
  Menuoption = 'center'
}
